import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { NamedLink } from '../../components';
import css from './GiftCardBanner.module.css';

const GiftCardBanner = ({ listing }) => {
  const title = listing?.attributes?.title || '';
  const firstImage = listing?.images?.[0];
  const imageUrl = firstImage?.attributes?.variants?.['landscape-crop']?.url || firstImage?.attributes?.variants?.['default']?.url;

  return (
    <div className={css.root}>
      <div className={css.content}>
        <h3 className={css.title}>
          <FormattedMessage id="GiftCardBanner.title" defaultMessage="Gift the Adventure" />
        </h3>
        <p className={css.text}>
          <FormattedMessage 
            id="GiftCardBanner.text" 
            defaultMessage="Send a gift card so they can book this adventure." 
          />
        </p>
        <NamedLink 
          name="GiftCardPage" 
          className={css.link}
          to={{
            state: { 
              suggestedListing: listing
            }
          }}
        >
          <FormattedMessage id="GiftCardBanner.linkText" defaultMessage="Buy Gift Card" />
        </NamedLink>
      </div>
    </div>
  );
};

export default GiftCardBanner;
